"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});const e=require("./index53.js");e.__exports.f=Object.getOwnPropertySymbols;exports.default=e.__exports;
